export default function StorySection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            以前の私も、あなたと同じ悩みを持っていました。でも・・・
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="order-2 md:order-1">
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl shadow-xl border border-gray-200">
              <p className="text-lg text-gray-800 leading-relaxed mb-6">
                はじめまして。<strong className="text-gray-900">佐々木 雄哉</strong>と申します。
              </p>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                私も昔は神奈川県に住んでいました。当時は住まいを東京に移したいと考えましたが、妻に家賃が高すぎると言われ諦めました。でも今となってはおかげさまで新宿に住まいを構えることができました。
              </p>
              <p className="text-lg font-bold text-gray-900 mb-4">
                そんな私がなぜ住めるようになったのか？
              </p>
              <p className="text-xl font-bold text-amber-600">
                家賃をほぼ無料にするノウハウを使っているからです。
              </p>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative rounded-xl overflow-hidden shadow-2xl border-4 border-gray-100 w-full h-64 md:h-96 lg:h-[500px]">
              <img
                src="https://static.readdy.ai/image/9700cfc123ce22cf391e77d50f0f2b6c/560f2df88090917806d0fd14d9e1f8c5.png"
                alt="佐々木 雄哉"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white p-10 md:p-14 rounded-xl shadow-2xl mb-12">
          <p className="text-2xl md:text-3xl font-bold text-center text-amber-400">
            詳しくお話したいので、もう少し聞いていただけますか？
          </p>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-xl shadow-2xl border-2 border-amber-200 mb-1">
          <div className="bg-gradient-to-br from-gray-50 to-amber-50 p-8 rounded-xl mb-8 border border-amber-100">
            <p className="text-lg text-gray-900 mb-4">ぶっちゃけます。僕の年収は1000万円です。</p>
            <p className="text-lg text-gray-900 mb-4">
              奥さんと子供3人います。1000万円でも東京だと家族で生きていくのにしんどいです。
            </p>
            <p className="text-lg text-gray-900 mb-4">
              けれども、今では貯金が毎月20万円以上出来ています。しかも余裕で。
            </p>
            <p className="text-2xl text-amber-600">
              それはなぜか？住宅費がほぼ無料だからです。
            </p>
          </div>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p className="text-gray-900">
              ちなみに、私が住んでいる家の家賃は20万円です。
            </p>
            <p>
              住む家のグレードや生活水準を下げたわけでもありません。<br className="hidden md:block" />
              特別なことをしている感覚もありません。
            </p>
            <p className="text-gray-900">
              それでも今では、家族と一緒に、心にも時間にも余裕のある<br className="hidden md:block" />
              豊かなライフスタイルを送れています。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}